import merchantCategoryCodeRoutes from '@/router/settings/account-merchant-category-code';
import { abasalaryMappingsRoutes } from '@/router/settings/accounting/abasalary-mappings';
import { apiTokensRoutes } from '@/router/settings/api-tokens';
import { emailRoutes } from '@/router/settings/email';
import { settingsTimeTrackingRoutes } from '@/router/settings/time-tracking';

const PassThrough = () => import('@/views/PassThrough.vue');
const PassThroughKeyed = () => import('@/views/PassThroughKeyed.vue');
const Registration = () => import('@/pages/settings/Registration.vue');
const RegistrationAccountPlanFlexible = () => import('@/pages/settings/RegistrationAccountPlanFlexible.vue');
const Settings = () => import('@/pages/settings/Settings.vue');
const SettingsAccountPlan = () => import('@/pages/settings/accounting/account-plan/SettingsAccountPlan.vue');
const SettingsAccountPlanBookingAccount = () => import('@/pages/settings/accounting/account-plan/SettingsAccountPlanBookingAccount.vue');
const SettingsAccountPlanClassification = () => import('@/pages/settings/accounting/account-plan/SettingsAccountPlanClassification.vue');
const SettingsAgreementsConfirmation = () => import('@/pages/settings/SettingsAgreementsConfirmation.vue');
const SettingsConfirm = () => import('@/pages/settings/SettingsConfirm.vue');
const SettingsKeyFigure = () => import('@/pages/settings/accounting/SettingsKeyFigure.vue');
const SettingsReceipt = () => import('@/pages/settings/SettingsReceipt.vue');
const SettingsUnitCreate = () => import('@/pages/settings/baseData/settings-unit/SettingsUnitCreate.vue');
const SettingsUnitView = () => import('@/pages/settings/baseData/settings-unit/SettingsUnitView.vue');
export const agbRouteName = 'SettingsAgreementsConfirmation';
export const confirmRouteName = 'SettingsConfirm';
export const flexibleAccountRegistrationRouteName = 'RegistrationAccountPlanFlexible';
export const registrationRouteName = 'SettingsRegistration';

export default [
  {
    path: '/settings',
    component: Settings,

    children: [
      ...apiTokensRoutes,
      ...abasalaryMappingsRoutes,
      ...emailRoutes,
      {
        path: '',
        name: 'settings',
        component: PassThrough,
        redirect: { name: 'SettingsList' },
        children: [
          {
            path: 'confirm',
            name: confirmRouteName,
            component: SettingsConfirm,
          },
          {
            path: 'agreements-confirm',
            name: agbRouteName,
            component: SettingsAgreementsConfirmation,
          },
          {
            path: 'registration',
            name: registrationRouteName,
            component: Registration,
          },
          {
            path: 'registration-account-plan-flexible',
            name: flexibleAccountRegistrationRouteName,
            component: RegistrationAccountPlanFlexible,
          },
          {
            path: 'list',
            name: 'SettingsList',
            redirect: '/v3/settings',
          },
          {
            path: 'company',
            name: 'SettingsCompanyDetail',
            redirect: '/v3/settings/company/company-data',
          },
          {
            path: 'user_management',
            name: 'SettingsPermissionManagement',
            redirect: '/v3/settings/company/user-management',
          },
          {
            path: 'user_management/user/:id?',
            name: 'SettingsPermissionUser',
            redirect: '/v3/settings/company/user-management/user/:id',
          },
          {
            path: 'user_management/group/:id',
            name: 'SettingsPermissionGroup',
            redirect: '/v3/settings/company/user-management/user-group/:id',
          },
          {
            path: 'localization',
            name: 'SettingsLocalization',
            redirect: '/v3/settings/company/localisation',
          },
          {
            path: 'modules',
            name: 'SettingsModules',
            redirect: '/v3/settings/company/modules',
          },
          {
            path: 'modules/abacus',
            name: 'SettingsModuleAbacus',
            redirect: '/v3/settings/company/modules/abacus',
          },
          {
            path: 'modules/abanet',
            name: 'SettingsModuleAbaNet',
            redirect: '/v3/settings/company/modules/abanet',
          },
          {
            path: 'modules/deepbox',
            name: 'SettingsModuleDeepBox',
            redirect: '/v3/settings/company/modules/deepbox',
          },
          {
            path: 'modules/deepcloud',
            name: 'SettingsModuleDeepCloud',
            redirect: '/v3/settings/company/modules/deepcloud',
          },
          {
            path: 'address',
            name: 'SettingsAddress',
            redirect: '/v3/settings/address/address',
          },
          {
            path: 'address/import-export',
            name: 'SettingsAddressImportExport',
            redirect: '/v3/settings/address/import-export',
          },
          {
            path: 'product',
            name: 'SettingsProduct',
            redirect: '/v3/settings/product/product',
          },
          {
            path: 'unit',
            name: 'SettingsUnit',
            component: PassThroughKeyed,
            redirect: { name: 'SettingsUnitView' },
            children: [
              {
                path: 'view',
                name: 'SettingsUnitView',
                component: SettingsUnitView,
                // redirect: '/v3/settings/base-data/units',
              },
              {
                path: 'create',
                name: 'SettingsUnitCreate',
                component: SettingsUnitCreate,
                // redirect: '/v3/settings/base-data/units/unit/create',
              },
              {
                path: 'edit/:unitUuid',
                props: true,
                name: 'SettingsUnitEdit',
                component: SettingsUnitCreate,
                // redirect: '/v3/settings/base-data/units/unit/:unitUuid',
              },
            ],
          },
          {
            path: 'receipt',
            name: 'SettingsReceipt',
            component: SettingsReceipt,
          },
          {
            path: 'supplier-credit-note',
            name: 'SettingsSupplierCreditNote',
            redirect: '/v3/settings/suppliers/supplier-credit-note',
          },
          {
            path: 'layout',
            name: 'SettingsDocumentDesign',
            redirect: '/v3/settings/customer/invoice-layout',
          },
          {
            path: 'document-designer',
            name: 'document-designer',
            redirect: '/v3/settings/customer/invoice-layout/designer',
          },

          {
            path: 'customer-portal/white-labeling',
            name: 'SettingsCustomerPortal',
            redirect: '/v3/settings/customer-portal/white-labeling',
          },
          {
            path: 'customer-portal/payment-providers',
            name: 'SettingsPaymentProviders',
            redirect: '/v3/settings/customer-portal/payment-providers',
          },

          {
            path: 'import-export',
            name: 'SettingsImportExport',
            redirect: '/v3/settings/base-data/import-export',
          },

          {
            path: 'invoice',
            name: 'SettingsInvoice',
            redirect: '/v3/settings/customer/invoices',
          },
          {
            path: 'dunning/:lvl?',
            name: 'SettingsDunning',
            redirect: '/v3/settings/customer/invoices/dunning/:lvl?',
          },
          {
            path: 'quote',
            name: 'SettingsQuote',
            redirect: '/v3/settings/customer/quotes',
          },
          {
            path: 'contract-note',
            name: 'SettingsContractNote',
            redirect: '/v3/settings/customer/contract-notes',
          },
          {
            path: 'delivery-note',
            name: 'SettingsDeliveryNote',
            redirect: '/v3/settings/customer/delivery-notes',
          },
          {
            path: 'credit-note',
            name: 'SettingsCreditNote',
            redirect: '/v3/settings/customer/credit-notes',
          },
          {
            path: 'mails',
            name: 'SettingsMails',
            redirect: '/v3/settings/customer/email',
          },
          {
            path: 'mail-designer',
            name: 'SettingsMailDesigner',
            redirect: '/v3/settings/customer/email/designer',
          },
          {
            path: 'mail/:id',
            name: 'SettingsMail',
            redirect: '/v3/settings/customer/email/templates/:id',
          },
          {
            path: 'currencies',
            name: 'SettingsCurrencies',
            redirect: '/v3/settings/accounting/currencies',
          },
          {
            path: 'currency/:id?',
            name: 'SettingsCurrency',
            redirect: '/v3/settings/accounting/currencies/currency/create',
          },
          {
            path: 'booking-years',
            name: 'SettingsJournalYears',
            redirect: '/v3/settings/accounting/booking-years',
          },
          {
            path: 'accounting',
            component: PassThroughKeyed,
            children: [
              ...merchantCategoryCodeRoutes,
              {
                path: 'account-plan',
                component: PassThroughKeyed,
                redirect: { name: 'settings-account-plan' },
                children: [
                  {
                    path: '',
                    name: 'settings-account-plan',
                    component: SettingsAccountPlan,
                  },
                  {
                    path: 'classification/:id?',
                    name: 'settings-account-plan-classification',
                    component: SettingsAccountPlanClassification,
                  },
                  {
                    path: 'booking-account/:id?',
                    name: 'settings-account-plan-booking-account',
                    component: SettingsAccountPlanBookingAccount,
                  },
                ],
              },
              {
                path: 'account-proposals',
                name: 'settings-account-proposals',
                redirect: '/v3/settings/accounting/account-assignments',
              },
            ],
          },
          {
            path: 'tax',
            component: PassThroughKeyed,
            redirect: { name: 'SettingsTax' },
            children: [
              {
                path: '',
                name: 'SettingsTax',
                redirect: '/v3/settings/accounting/tax',
              },
              {
                path: 'timeline/:uuid?',
                name: 'SettingsTaxTimeline',
                redirect: '/v3/settings/accounting/tax/timeline/:uuid?',
              },
              {
                path: 'rate/:id?',
                name: 'SettingsTaxRate',
                redirect: '/v3/settings/accounting/tax',
              },
            ],
          },
          {
            path: 'key-figures',
            name: 'SettingsKeyFigures',
            redirect: '/v3/settings/accounting/key-figures',
          },
          {
            path: 'key-figures/year/:id?',
            name: 'SettingsKeyFigure',
            component: SettingsKeyFigure,
          },
          {
            path: 'general/display',
            name: 'settings-general-display',
            redirect: '/v3/settings/general/display-options',
          },

          ...settingsTimeTrackingRoutes,
        ],
      },
    ],
  },
];
